export const ConditionIcon = ({
  className,
  strokeWidth,
}: {
  className?: string;
  strokeWidth?: number;
}) => (
  <div
    className={`${className ? className + " " : ""}relative flex items-center justify-center`}
  >
    <span className="absolute text-sm font-extrabold leading-[100%]">?</span>
    <ConditionSVG strokeWidth={strokeWidth} />
  </div>
);

export const ConditionSVG = ({strokeWidth = 2}: {strokeWidth?: number}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="24"
    height="24"
    fill="none"
  >
    <path
      d="M8 3H7a2 2 0 0 0-2 2v5a2 2 0 0 1-2 2 2 2 0 0 1 2 2v5c0 1.1.9 2 2 2h1"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 21h1a2 2 0 0 0 2-2v-5c0-1.1.9-2 2-2a2 2 0 0 1-2-2V5a2 2 0 0 0-2-2h-1"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
